import { TRACKABLE_EVENTS_METADATA } from 'helpers/trackerHelpers';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { getColDefs } from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/Absence/helpers/colDefinitions';
import { DateVentilation } from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/helpers/hrVizInfos';
import {
    DateString,
    Absence,
} from 'routes/HumanResourcesModule/business/types';
import HrDataGrid from 'routes/HumanResourcesModule/components/HrDataGrid/HrDataGrid';

type Props = {
    exercice: number;
    cardHeaderActions: React.ReactNode;
    absenceData: Absence[];
    dateColumns: DateString[];
    isLoading: boolean;
    dateVentilation: DateVentilation;
    showLastYearColumns: boolean;
};

const AbsenceGrid = ({
    exercice,
    cardHeaderActions,
    absenceData,
    dateColumns,
    isLoading,
    dateVentilation,
    showLastYearColumns,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const isMonthly = dateVentilation === DateVentilation.MONTHLY;

    const columnDefs = getColDefs({
        dateColumns,
        isMonthly,
        exercice,
        showLastYearColumns,
        isForPermanentAgent: true,
        t,
    });

    const exportFileName = t('humanResources.payState.absenceExportFileName', {
        dateVentilation: t(`humanResources.${dateVentilation}`).toLowerCase(),
    });

    return (
        <HrDataGrid
            title={t('humanResources.absences')}
            rowData={absenceData}
            columnDefs={columnDefs}
            trackEventMetadata={{
                gridName:
                    TRACKABLE_EVENTS_METADATA.human_resources.fullScreen
                        .absenceGrid,
            }}
            exportFileName={exportFileName}
            isLoading={isLoading}
            cardHeaderActions={cardHeaderActions}
        />
    );
};

export default memo(AbsenceGrid);
